import React from "react";
import { MessageBanner, MultiColumnList } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import styles from "./themaImport.module.css";
export var ThemaImportProgress = function (_a) {
    var progress = _a.progress;
    var formatMessage = useIntl().formatMessage;
    var bannerType = progress.status === "COMPLETED"
        ? "success"
        : progress.status === "FAILED"
            ? "error"
            : "default";
    if (progress.status === "DOWNLOADING") {
        return (React.createElement("div", null,
            React.createElement(MessageBanner, { type: "default" },
                React.createElement(FormattedMessage, { id: "ui-br-agency.import.status.DOWNLOADING" }))));
    }
    var percentage = progress.totalRecords > 0
        ? Math.round((progress.currentRecord / progress.totalRecords) * 100)
        : 0;
    var fillClass = progress.status === "FAILED"
        ? styles.progressBarFillError
        : styles.progressBarFill;
    return (React.createElement("div", null,
        React.createElement(MessageBanner, { type: bannerType },
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.status.".concat(progress.status) })),
        React.createElement("div", { className: styles.progressBarContainer },
            React.createElement("div", { className: styles.progressBarTrack },
                React.createElement("div", { className: fillClass, style: { width: "".concat(percentage, "%") } }))),
        React.createElement("div", { className: styles.statsContainer },
            progress.currentRecord,
            " / ",
            progress.totalRecords,
            " ",
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.thema.stat.rows" }),
            " (",
            progress.successCount,
            " ",
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.thema.stat.codetables" }),
            progress.failedCount > 0 && (React.createElement(React.Fragment, null,
                ", ",
                progress.failedCount,
                " ",
                React.createElement(FormattedMessage, { id: "ui-br-agency.import.failed" }))),
            ")"),
        progress.failedRecords && progress.failedRecords.length > 0 && (React.createElement(MultiColumnList, { contentData: progress.failedRecords, visibleColumns: ["recordNumber", "controlNumber", "errorMessage"], columnMapping: {
                recordNumber: "#",
                controlNumber: formatMessage({
                    id: "ui-br-agency.import.thema.codetable",
                }),
                errorMessage: formatMessage({
                    id: "ui-br-agency.import.error",
                }),
            }, columnWidths: {
                recordNumber: "80px",
                controlNumber: "250px",
            } }))));
};
